export default "/images/5b92f94a8cec83f6dbd4e04172595207.avif";